<template>
  <div>
    <v-row justify="center" class="mx-xl-6 mx-lg-6 mx-md-6" no-gutters>
      <v-col xl="9" lg="11" md="12" sm="12" cols="12">
        <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
          <v-col class="pr-xl-3 pr-lg-3 pr-md-3" xl="8" lg="8" md="8" sm="12" cols="12">
            <v-card class="mx-auto" outlined>
              <v-toolbar flat dense color="#F9F9F9">
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="text-left py-0 px-0">
                <v-skeleton-loader type="list-item-two-line" tile></v-skeleton-loader>
              </v-card-text>
              <v-divider></v-divider>
              <v-toolbar flat dense color="#F9F9F9">
              </v-toolbar>
              <v-card-text class="py-0 px-0">
                <v-skeleton-loader v-for="i in 5" type="list-item-avatar-three-line" :key="i + '_item'" tile></v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col class="pl-xl-3 pl-lg-3 pl-md-3" xl="4" lg="4" md="4" sm="12" cols="12">
            <v-card class="mx-auto" outlined>
              <v-toolbar flat dense color="#F9F9F9">
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text class="text-left px-0">
                <v-skeleton-loader type="list-item-three-line" tile></v-skeleton-loader>
                <v-skeleton-loader type="list-item-two-line" tile></v-skeleton-loader>
                <v-divider class="mt-2"></v-divider>
                <v-skeleton-loader type="actions" tile></v-skeleton-loader>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CheckoutLoader'
}
</script>
